import Profile from './views/Profile.vue'
import Receipts from './views/Receipts.vue'
import HomeLayout from '@/layouts/Home.vue'
import Vacactions from './views/Vacations.vue'
import Licenses from './views/Licenses.vue'
import DocumentFiles from './views/Document&Policies.vue'

export const employeesRoutes = [
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/receipts',
    name: 'receipts',
    component: Receipts,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/vacations',
    name: 'Vacations',
    component: Vacactions,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/licenses',
    name: 'Licenses',
    component: Licenses,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/documents&Policies',
    name: 'Documents & Policies',
    component: DocumentFiles,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
]
